/*
 * @Author: wangshengqiang
 * @Date: 2021-05-19 10:46:43
 * @LastEditTime: 2021-05-24 18:21:46
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useContext } from 'react';
import { ModuleContext } from '../BaseModule';
import './index.less';

const BenefitDemonstrationFactor = (props = {}) => {
  const {
    attrs
  } = props;
  const {
    benefitTable
  } = useContext(ModuleContext);
  const {
    benefitFactors = []
  } = benefitTable || {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, attrs.isShow && /*#__PURE__*/React.createElement("div", {
    className: "factor"
  }, (benefitFactors === null || benefitFactors === void 0 ? void 0 : benefitFactors.length) > 0 && /*#__PURE__*/React.createElement("p", null, benefitFactors.join('/'))));
};

export default BenefitDemonstrationFactor;